import { checkOrganizationType } from '@/router/guards/check-organization-type';
import { checkServicesPagePermissions } from '@/router/guards/my-org-company.guards';
import type { RouteRecordRaw } from 'vue-router';

export default {
  path: 'org-company/:idElement',
  name: 'MyOrgCompany',
  component: () => import('@/views/private/MyOrgCompany.vue'),
  props: true,
  children: [
    {
      path: 'anagrafica',
      name: 'MyOrgCompanyAnagrafica',
      component: () => import('@/components/my-org-company/Anagrafica.vue'),
    },
    {
      path: 'sincronizzazione',
      name: 'MyOrgCompanySincronizzazione',
      component: () => import('@/components/my-org-company/sincronizzazione/Sincronizzazione.vue'),
    },
    {
      path: 'moduli',
      name: 'MyOrgCompanyModuli',
      component: () => import('@/components/my-org-company/Moduli.vue'),
    },
    {
      path: 'preferenze-corrispondenza',
      name: 'MyOrgCompanyPreferenzeCorrispondenza',
      component: () => import('@/components/my-org-company/PreferenzeCorrispondenza.vue'),
    },
    {
      path: 'tipologie-servizi',
      name: 'MyOrgCompanyTipologieServizi',
      component: () => import('@/components/my-org-company/TipologieServizi.vue'),
      beforeEnter: [checkServicesPagePermissions],
    },
    {
      path: 'associazione-fornitori',
      name: 'MyOrgCompanyAssociazioneFornitori',
      component: () => import('@/components/my-org-company/AssociazioneFornitori.vue'),
    },
    {
      path: 'funzionalita-aggiuntive',
      name: 'MyOrgCompanyFunzionalitaAggiuntive',
      component: () => import('@/components/my-org-company/FunzionalitaAggiuntive.vue'),
    },
    {
      path: 'qualifiche-fornitori',
      name: 'MyOrgCompanySupplierQualifications',
      component: () => import('@/components/my-org-company/SupplierQualifications.vue'),
    },
    {
      path: 'gestione-ras',
      name: 'MyOrgCompanyRasPurchase',
      component: () => import('@/components/my-org-company/RasPurchase.vue'),
    },
    {
      path: 'gestione-documentale-fornitori',
      name: 'MyOrgCompanyDocumentalePurchase',
      component: () => import('@/components/my-org-company/DocumentalePurchase.vue'),
    },
    {
      path: 'preferenze-email',
      name: 'MyOrgEmailPreferences',
      component: () => import('@/components/my-org-company/CustomEmail.vue'),
    },
  ],
  beforeEnter: [checkOrganizationType],
} as RouteRecordRaw;
